import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_VDAY_75: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_VDAY_75,
  },
  {
    pageId: PageId.CHAT_UPSELL_VDAY_75,
  },
  {
    pageId: PageId.UPSELL_VDAY_75,
  },
  {
    pageId: PageId.DOWNLOAD_VDAY_75,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
